import { Component, OnInit } from '@angular/core';
import { MsgsService, Template } from 'generated-sources/openapi';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.css']
})
export class TemplatesComponent implements OnInit {
  cards = new BehaviorSubject<Template[]>(null);
  selected: Template;
  constructor(private service: MsgsService) { }

  ngOnInit(): void {
    this.load();
  }

  load() {
    return this.service.msgsTemplatesGet().toPromise().then((r) => this.cards.next(r));
  }

  remove(id: number) {
    this.service.msgsTemplatesIdDelete(`${id}`).toPromise().then((r) => this.load());
  }

  edit(id: number) {
    this.selected = this.cards.value.find(v => v.id === id);
  }

  startNew() {
    this.selected = {};
  }

  completed(evt: Template) {
    console.log(evt);
    this.selected = null;
    if (evt) {
      let p: Promise<any>;
      if (evt.id) {
        p = this.service.msgsTemplatesIdPost(`${evt.id}`, evt).toPromise();
      } else {
        p = this.service.msgsTemplatesPut(evt).toPromise();
      }
      p.then(() => this.load());
    }
  }

}
